import { useMiningLands } from '../hooks/useMiningLands';
import { MiningLandCard } from '../components/MiningLandCard';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export function MiningLandsPage() {
  const { lands, loading, error, refresh } = useMiningLands();

  if (loading) {
    return (
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">Mining Lands</h2>
        <div className="grid gap-4 md:grid-cols-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-32" />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">Mining Lands</h2>
        <p className="text-destructive">{error}</p>
        <Button onClick={refresh} variant="outline">
          Retry
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Mining Lands</h2>
        <Button onClick={refresh} variant="outline" size="sm">
          Refresh
        </Button>
      </div>

      {lands.length === 0 ? (
        <p className="text-muted-foreground">
          No mining lands yet. Lands will be generated when you start mining from a game client.
        </p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {lands.map((land) => (
            <MiningLandCard key={land.landId} land={land} />
          ))}
        </div>
      )}
    </div>
  );
}
